import { db, firebase } from "../../../config/firebase/firebase-config";
import { ITrdProductionOffices } from "../../../redux/types/types";
import { IValidateProductionOffice } from "../form/IValidateProductionOffice";

export const deleteProductionOfficeFirebase = async (
  value: IValidateProductionOffice
) => {
  try {
    await db
      .collection("Entities")
      .doc(value.idEntity)
      .collection("ProductionOffices")
      .doc(value.idProductionOffice)
      .delete();
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// Agregar oficina productora
export const addOrUpdateProductionOffice = async (
  idEntity: string,
  office: ITrdProductionOffices
) => {
  try {
    await db
      .collection("Entities")
      .doc(idEntity)
      .collection("ProductionOffices")
      .doc(office.idProductionOffice)
      .set(office, { merge: true });
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

export const existsProductionOffice = async (
  idEntity: string,
  idVersion: string,
  code: string,
  name: string,
  edit: boolean
) => {
  let offices: any[] = [];
  const refProduction = db
    .collection("Entities")
    .doc(idEntity)
    .collection("ProductionOffices");

  if (!edit) {
    const officesCodeSnap = await refProduction
      .where("idVersion", "==", idVersion)
      .where("code", "==", code)
      .get();
    officesCodeSnap.forEach((snap) => {
      offices.push({
        id: snap.id,
        ...snap.data(),
      });
    });
  }

  const officesNameSnap = await refProduction
    .where("idVersion", "==", idVersion)
    .where("name", "==", name)
    .get();
  officesNameSnap.forEach((snap) => {
    offices.push({
      id: snap.id,
      ...snap.data(),
    });
  });

  return offices;
};

export const getOfficesbyIdProductionOffice = async (
  value: IValidateProductionOffice
) => {
  const seriesSnap = await db
    .collection("Entities")
    .doc(value.idEntity)
    .collection("ProductionOffices")
    .doc(value.idProductionOffice)
    .collection("Offices")
    .get();
  let offices: any[] = [];

  seriesSnap.forEach((snap) => {
    offices.push({ ...snap.data() });
  });

  return offices;
};

export const getProductionOfficeAndOfficeById = async (
  value: IValidateProductionOffice
) => {
  const productionOfficeRef = await db
    .collection("Entities")
    .doc(value.idEntity)
    .collection("ProductionOffices")
    .doc(value.idProductionOffice);

  // Recuperar el documento de ProductionOffices
  const productionOfficeSnap = await productionOfficeRef.get();
  if (!productionOfficeSnap.exists) {
    throw new Error("Production office not found");
  }

  if (!productionOfficeSnap.exists) {
    throw new Error("Production office not found");
  }

  // Extraer los datos del documento principal
  const productionOfficeData = {
    id: productionOfficeSnap.id,
    ...productionOfficeSnap.data(),
  };

  // Recuperar los documentos de la subcolección Offices
  const officesSnap = await productionOfficeRef.collection("Offices").get();
  const officesData = officesSnap.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  // Combinar ambos resultados
  return {
    ...productionOfficeData,
    offices: officesData,
  };
};
